export class DeleteKeyValueRequest {
  public id!:number;
}
